// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var EmailNotificationsTemplateEditController = function ($scope,
    $routeParams,
    EmailNotificationsTemplate,
    EmailTemplatePlaceholder,
    Attachment,
    gettext,
    gettextCatalog,
    CustomerEmailNotificationEvents,
    $location,
    GeneralEmailSettings) {

    //set defaults and constants
    $scope.allAttachmentsDetails = { Count: 0, CommonSize: 0 };
    $scope.limit = 5;
    $scope.newStep = {};
    const customerEmailNotification = "CustomerEmailNotification";
    const orderRelatedCustomerEmailNotification = "OrderRelatedCustomerEmailNotification";

    $scope.generalSettings = GeneralEmailSettings.get({}, function () { });

    if ($routeParams.templateId)
        $scope.template = EmailNotificationsTemplate.get({ id: $routeParams.templateId });
    else {
        $scope.template = new EmailNotificationsTemplate();
        $scope.template.EmailType = "CustomerEmailNotification";
        $scope.template.Subject = { "de": gettextCatalog.getString(gettext("CustomerEmailNotification")), "_c": gettextCatalog.getString(gettext("CustomerEmailNotification")) };
        $scope.template.HtmlText = { "de": "", "_c": "" };
    }
    
    const getFilteredPlaceholdersByTemplates = function (placeholders, selectedTemplate) {
        if (selectedTemplate) {
            if(selectedTemplate === "OrderSucceeded")
            {
                return placeholders.filter(function (placeholder) {
                    // I dont wont iterate two times throw one collection here and next 
                    // will refactor during testing [NC]
                    return (placeholder.AvailableTemplates.indexOf(customerEmailNotification) !== -1) ||
                        (placeholder.AvailableTemplates.indexOf(orderRelatedCustomerEmailNotification) !== -1 )
                });
            }
            
            return placeholders.filter(function (placeholder) {
                return (placeholder.AvailableTemplates.indexOf(selectedTemplate) !== -1) ||
                    (placeholder.AvailableTemplates.indexOf(customerEmailNotification) !== -1)
            })
        }
        
        else {
            return placeholders.filter(function (placeholder) {
                return (placeholder.AvailableTemplates.indexOf(customerEmailNotification) !== -1);
            });
        }
    };

    $scope.customerEmailNotificationEvents = CustomerEmailNotificationEvents.query();
    $scope.placeholders = EmailTemplatePlaceholder.query()
    $scope.placeholders.$promise.then(function(placeholders) {
        let selectedTemplate = $scope.template ? $scope.template.EventType : $scope.template;
        $scope.filteredPlaceholders = getFilteredPlaceholdersByTemplates(placeholders, selectedTemplate);
    });

    $scope.addLanguage = function (newKey) {
        if ($scope.template.Subject[newKey])
            return; // already exists
        $scope.template.Subject[newKey] = gettextCatalog.getString(gettext('Subject'));
    };

    $scope.$watch("template.EventType",
        function (newValue, oldValue) {
            if (newValue && newValue !== oldValue) {
                $scope.filteredPlaceholders =  getFilteredPlaceholdersByTemplates($scope.placeholders, newValue);
            }
        });

    $scope.removeLanguage = function (key) {
        $scope.yesCancel(gettextCatalog.getString(gettext("Delete Language")),
            gettextCatalog.getString(gettext("Are you sure?")),
            function () {
                delete $scope.template.Subject[key];
                delete $scope.template.HtmlText[key];
            });
    };

    $scope.AttachmentsList = Attachment.get({}, function () { $scope.calcTotalAndManageSelectList(); });

    $scope.addStep = function () {
        if (!$scope.template.Attachments)
            $scope.template.Attachments = [];
        //additional check
        if (!$scope.template.Attachments.includes($scope.newStep.Id)) {
            $scope.template.Attachments.push($scope.newStep.Id);
            $scope.calcTotalAndManageSelectList();
            $scope.newStep = {};
        } else {
            $scope.notify('error', 'Attachment already added: ' + $scope.getInfo($scope.newStep.Id).AttName);
        }
    };

    $scope.removeStep = function (step) {
        $scope.template.Attachments.destroy(step);
        $scope.calcTotalAndManageSelectList();
    };

    $scope.getInfo = function (id) {
        if ($scope.AttachmentsList.attachments) {
            var res = $scope.AttachmentsList.attachments.filter(function (element) {
                return element.Id === id;
            });
            if (res.length > 0) {
                return { AttName: res[0].InternalName, AttFileSize: res[0].Files['_c'].FileSize };
            }
        }
        return { AttName: "...", AttFileSize: "..." };

    };

    $scope.calcTotalAndManageSelectList = function () {

        var calcSum = function (attachmentItems, prop) {
            return attachmentItems.reduce(function (a, b) {
                return a + b.Files["_c"][prop];
            }, 0);
        };

        // null checks
        $scope.allAttachmentsDetails = { Count: 0, CommonSize: 0 };

        if (!$scope.template.Attachments) {
            $scope.template.Attachments = [];
        }

        //recalculate Total
        $scope.allAttachmentsDetails.Count = $scope.template.Attachments.length;
        var alreadyChosenAttachments = $scope.AttachmentsList.attachments.filter(function (element) {
            return $scope.template.Attachments.includes(element.Id);
        });
        $scope.allAttachmentsDetails.CommonSize = calcSum(alreadyChosenAttachments, 'FileSize');

        //display only remaining Attachments in selectList
        $scope.notYetChosenAttachments = $scope.AttachmentsList.attachments.filter(function (element) {
            return !$scope.template.Attachments.includes(element.Id);
        });
    };

    function saveSuccess() {
        $scope.notifySuccess();
        $location.path("/settings/email-notifications-templates");
    }

    $scope.save = function () {
        if ($routeParams.templateId) {
            $scope.template.$update({ id: $routeParams.templateId }, function () {
                saveSuccess();
            });
        } else {
            $scope.template.$save({}, function () {
                saveSuccess();
            });
        }
    };

};
EmailNotificationsTemplateEditController.$inject = ['$scope', '$routeParams', 'EmailNotificationsTemplate', 'EmailTemplatePlaceholder', 'Attachment', 'gettext', 'gettextCatalog', 'CustomerEmailNotificationEvents', '$location', 'GeneralEmailSettings'];
